import { lazyLoadOnRender } from '@ms/yammer-libs-lazy';
import type { ComponentType } from 'react';

const AppSearchNavPhase1 = () => import(/* webpackChunkName: "4-feat-search-nav-phase1" */ './AppSearchNavPhase1');
const LoadableAppSearchNavPhase1: ComponentType = lazyLoadOnRender({ loader: AppSearchNavPhase1 });
export default LoadableAppSearchNavPhase1;
